import {
  IError,
  IProfileConsentManagement,
  IQueryHookOptions,
} from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { revokeConsent } from 'services';

type RevokeConsentFunction = UseMutateAsyncFunction<
  IProfileConsentManagement,
  IError
>;

type UseRevokeConsent = [RevokeConsentFunction, IQueryHookOptions];

export const useRevokeConsent = (profileId = ''): UseRevokeConsent => {
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IProfileConsentManagement,
    IError
  >(() => revokeConsent(profileId));

  return [mutateAsync, { error, isError, isLoading }];
};
